import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom"; 
import "./ProductPage.css";
import axios from "axios";
import he from "he";
import { baseURl } from "../../config";
import {fixImagePaths} from "../util"

const ProductsSection = () => {
  const [products, setProducts] = useState([]);
  const [visibleProducts, setVisibleProducts] = useState(6);
  const [isLoading, setIsLoading] = useState(true);
  const sectionRef = useRef(null);
  const [sections, setSections] = useState([]);
  const navigate = useNavigate(); 

  const decodeHTML = (html) => {
    if (!html) return "";
    return he.decode(html);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${baseURl}/api/v1/page`);
        setSections(response.data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(`${baseURl}/api/v1/product`);
        const data = await response.json();

        if (data.success && data.data) {
          // Sort products by seriesNumber in ascending order
          const sortedProducts = data.data.sort((a, b) => a.seriesNumber - b.seriesNumber);
          setProducts(sortedProducts);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Failed to fetch products:", error);
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleShowMore = () => setVisibleProducts((prev) => prev + 3);
  const handleShowLess = () => setVisibleProducts(3);

  const handleProductClick = (product) => {
    navigate(`/product-details2/${product._id}`, { state: { product } }); 
  };

  const imageBaseURL = "https://akinex-api.algosu.com/";

  return (
    <section id="products-section" className="products-section" ref={sectionRef}>
      <div className="products-container">
        <div>
          {sections.map((section, index) => (
            <div key={index}>
              {section.product_section && section.product_section.htmlContent && (
                <div
                  className="ProductSection"
                  dangerouslySetInnerHTML={{ __html: fixImagePaths(decodeHTML(section.product_section.htmlContent)) }}
                />
              )}
            </div>
          ))}
        </div>
        <div className="products-grid">
          {isLoading
            ? [...Array(visibleProducts)].map((_, index) => (
                <div key={index} className="skeleton-card"></div>
              ))
            : products.slice(0, visibleProducts).map((product) => (
                <div
                  key={product._id}
                  className="product-card"
                  onClick={() => handleProductClick(product)} 
                >
                  <img src={`${imageBaseURL}${product.productImage}`} alt={product.title} />
                  <h3>{decodeHTML(product.title)}</h3>
                  {product.description && <p>{decodeHTML(product.description)}</p>}
                </div>
              ))}
        </div>
        <div className="show-more">
          {visibleProducts < products.length ? (
            <button onClick={handleShowMore}>View All →</button>
          ) : (
            <button onClick={handleShowLess}>Show Less</button>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;